import { css } from "@emotion/react";
import { rem } from "polished";
import React from "react";

import { Flex, Label } from "../base";

const MiniCheckbox = ({ label, checked, onCheck }) => (
  <Flex
    css={css`
      cursor: pointer;
    `}
    onClick={() => onCheck(!checked)}
  >
    <input
      checked={checked}
      css={css`
        position: relative;
        top: ${rem(1)};
        margin-right: ${rem(8)};

        width: ${rem(14)};
        height: ${rem(14)};
      `}
      type="checkbox"
    />
    <Label light small color="#999">
      {label}
    </Label>
  </Flex>
);

export default MiniCheckbox;
